var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgMessagesEllipsis(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M16.5 8c1.149 0 2.12.781 2.41 1.84l.039.16H25.5a2.504 2.504 0 012.495 2.336L28 12.5v6a2.504 2.504 0 01-2.336 2.495L25.5 21h-.306l.78 2.342a.5.5 0 01-.397.652L25.5 24a.5.5 0 01-.23-.056l-.07-.044-3.867-2.9H15.5a2.505 2.505 0 01-2.41-1.84l-.04-.16h-2.384L6.8 21.9a.497.497 0 01-.221.094L6.5 22a.501.501 0 01-.495-.568l.021-.09.78-2.342H6.5a2.504 2.504 0 01-2.495-2.336L4 16.5v-6a2.504 2.504 0 012.336-2.495L6.5 8h10zm-.995 3a1.5 1.5 0 00-1.493 1.356l-.007.144v6.07l.026.23.029.12c.144.491.532.879 1.023 1.021l.173.039.1.013.144.007h6a.5.5 0 01.232.057l.062.039 2.726 2.044-.494-1.481a.503.503 0 01.379-.65L24.5 20h1c.778 0 1.42-.596 1.493-1.356L27 18.5v-6c0-.827-.673-1.5-1.5-1.5h-9.995zm.995-2h-10c-.778 0-1.42.596-1.493 1.356L5 10.5v6c0 .778.596 1.42 1.356 1.493L6.5 18h1a.499.499 0 01.496.566l-.022.093-.494 1.481 2.72-2.04a.494.494 0 01.22-.094L10.5 18h2.504v-5.5a2.5 2.5 0 012.336-2.495l.165-.005h2.409a1.503 1.503 0 00-.458-.654l-.15-.108-.045-.03-.068-.037-.135-.062-.156-.054A1.484 1.484 0 0016.5 9zm1 5.5a1 1 0 110 2 1 1 0 010-2zm3 0a1 1 0 110 2 1 1 0 010-2zm3 0a1 1 0 110 2 1 1 0 010-2z"
  }));
}

export default SvgMessagesEllipsis;